/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData from './PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData';

/**
 * The PerplayStatisticsControllerDtoNftLevelStatStatisticsNftLevelStatData model module.
 * @module model/PerplayStatisticsControllerDtoNftLevelStatStatisticsNftLevelStatData
 * @version 1.0
 */
class PerplayStatisticsControllerDtoNftLevelStatStatisticsNftLevelStatData {
    /**
     * Constructs a new <code>PerplayStatisticsControllerDtoNftLevelStatStatisticsNftLevelStatData</code>.
     * @alias module:model/PerplayStatisticsControllerDtoNftLevelStatStatisticsNftLevelStatData
     */
    constructor() { 
        
        PerplayStatisticsControllerDtoNftLevelStatStatisticsNftLevelStatData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PerplayStatisticsControllerDtoNftLevelStatStatisticsNftLevelStatData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PerplayStatisticsControllerDtoNftLevelStatStatisticsNftLevelStatData} obj Optional instance to populate.
     * @return {module:model/PerplayStatisticsControllerDtoNftLevelStatStatisticsNftLevelStatData} The populated <code>PerplayStatisticsControllerDtoNftLevelStatStatisticsNftLevelStatData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PerplayStatisticsControllerDtoNftLevelStatStatisticsNftLevelStatData();

            if (data.hasOwnProperty('targetDate')) {
                obj['targetDate'] = ApiClient.convertToType(data['targetDate'], 'Date');
            }
            if (data.hasOwnProperty('carLevelDistribution')) {
                obj['carLevelDistribution'] = ApiClient.convertToType(data['carLevelDistribution'], [PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData]);
            }
            if (data.hasOwnProperty('totalCarLevelDistribution')) {
                obj['totalCarLevelDistribution'] = ApiClient.convertToType(data['totalCarLevelDistribution'], [PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData]);
            }
            if (data.hasOwnProperty('totalCarStatsDistribution')) {
                obj['totalCarStatsDistribution'] = ApiClient.convertToType(data['totalCarStatsDistribution'], [PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PerplayStatisticsControllerDtoNftLevelStatStatisticsNftLevelStatData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PerplayStatisticsControllerDtoNftLevelStatStatisticsNftLevelStatData</code>.
     */
    static validateJSON(data) {
        if (data['carLevelDistribution']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['carLevelDistribution'])) {
                throw new Error("Expected the field `carLevelDistribution` to be an array in the JSON data but got " + data['carLevelDistribution']);
            }
            // validate the optional field `carLevelDistribution` (array)
            for (const item of data['carLevelDistribution']) {
                PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData.validateJSON(item);
            };
        }
        if (data['totalCarLevelDistribution']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['totalCarLevelDistribution'])) {
                throw new Error("Expected the field `totalCarLevelDistribution` to be an array in the JSON data but got " + data['totalCarLevelDistribution']);
            }
            // validate the optional field `totalCarLevelDistribution` (array)
            for (const item of data['totalCarLevelDistribution']) {
                PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData.validateJSON(item);
            };
        }
        if (data['totalCarStatsDistribution']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['totalCarStatsDistribution'])) {
                throw new Error("Expected the field `totalCarStatsDistribution` to be an array in the JSON data but got " + data['totalCarStatsDistribution']);
            }
            // validate the optional field `totalCarStatsDistribution` (array)
            for (const item of data['totalCarStatsDistribution']) {
                PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Date} targetDate
 */
PerplayStatisticsControllerDtoNftLevelStatStatisticsNftLevelStatData.prototype['targetDate'] = undefined;

/**
 * @member {Array.<module:model/PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData>} carLevelDistribution
 */
PerplayStatisticsControllerDtoNftLevelStatStatisticsNftLevelStatData.prototype['carLevelDistribution'] = undefined;

/**
 * @member {Array.<module:model/PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData>} totalCarLevelDistribution
 */
PerplayStatisticsControllerDtoNftLevelStatStatisticsNftLevelStatData.prototype['totalCarLevelDistribution'] = undefined;

/**
 * @member {Array.<module:model/PerplayStatisticsControllerDtoNftLevelStatTimeSeriesData>} totalCarStatsDistribution
 */
PerplayStatisticsControllerDtoNftLevelStatStatisticsNftLevelStatData.prototype['totalCarStatsDistribution'] = undefined;






export default PerplayStatisticsControllerDtoNftLevelStatStatisticsNftLevelStatData;

